// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// The unique code of the accordion.
// Example: "H_FEM_BASIC_PARAMS"

export const accordionCodeMinLength = 1;
export const accordionCodeMaxLength = 20;

export const AccordionCodeSchema = t.refinement(t.string, n => n.length >= accordionCodeMinLength && n.length <= accordionCodeMaxLength, 'AccordionCode');

export type AccordionCode = string;
